import { render, staticRenderFns } from "./logdetail.vue?vue&type=template&id=1f5980e8&scoped=true&"
import script from "./logdetail.vue?vue&type=script&lang=js&"
export * from "./logdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5980e8",
  null
  
)

export default component.exports